import React from "react";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import Box from "../../component/Box/Box";
import {ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import CommissioningService from "../../services/CommissioningService";
import ProductTypeSelector from "../../productType/component/ProductTypeSelector";
import CheckpointSelector from "../../checkpoint/CheckpointSelector";
import Notify from "../../services/Notify";
import FormButtons from "../../component/Form/FormButtons";
import Loading from "../../component/Loading/Loading";

class CommissionerPage extends React.Component {

  service = new CommissioningService();

  constructor(props) {
    super(props);
    this.state = {created: false};
    this.restartCommission = this.restartCommission.bind(this);
  }

  restartCommission() {
    const {productTypeId, checkpointId, entity = {}, tagId} = this.state;
    this.setState({loading: true, message: 'Comissionando...'});
    entity.checkpointId = checkpointId;
    entity.productTypeId = productTypeId;
    entity.tagId = tagId.value;
    this.service.commissioner(checkpointId, productTypeId, 1, tagId.value).then(
        (data) => {
          Notify.success("EPCs gerados");
          entity.tagId = '';
          this.setState({loading: false, entity, epcs: data.epc.value, created: true});
        },
        (error) => {
          Notify.error("Problema ao gerar EPC", error);
          this.setState({loading: false, entity, message: null});
        }
    );
  }

  render() {
    const {loading, message, entity} = this.state;
    if (loading) {
      return <Loading message={message}/>
    }

    const breadcrumbs = [
      <BreadcrumbItem key={2} title="Comissionador" active={true}/>];
    return (
        <Page title="Comissionador" breadcrumbs={breadcrumbs}>
          <Box info>
            <form ref={form => (this.form = form)}
                  onSubmit={event => {
                    event.preventDefault();
                    this.restartCommission();
                  }}>

              <CheckpointSelector required={true} commissioner defaultValue={entity && entity.checkpointId} setValue={value => this.state.checkpointId = value}/>

              <ProductTypeSelector required={true} defaultValue={entity && entity.productTypeId} setValue={value => this.state.productTypeId = value}/>

              <FormGroup>
                <ControlLabel>Tag ID</ControlLabel>
                <input type="text" className="form-control"
                       placeholder="Identificação escrita na tag (ou leitura de QrCode)"
                       defaultValue={entity && entity.tagId}
                       ref={value => (this.state.tagId = value)} name="tagId"
                />
              </FormGroup>

              <FormGroup controlId="formControlsEpcs">
                <ControlLabel>EPCs gerados</ControlLabel>
                <FormControl componentClass="textarea" value={this.state.epcs}
                             readOnly={true}/>
              </FormGroup>

              <FormButtons history={this.props.history}/>
            </form>
          </Box>
        </Page>);
  }
}

export default CommissionerPage;



// WEBPACK FOOTER //
// ./src/pages/Commissioner/CommissionerPage.js